"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootTrendsSagas = void 0;
var ChartApiSaga_1 = require("@/pages/chart/api/ChartApiSaga");
var ChartRangeType_1 = require("@/pages/chart/states/ChartRangeType");
var DataGroupType_1 = require("@/pages/chart/states/DataGroupType");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var TrendsAction_1 = require("@/pages/common/actions/TrendsAction");
var ChartGroupNewType_1 = require("@/pages/common/states/ChartGroupNewType");
var Pages_1 = require("@/rendering/common/Pages");
var effects_1 = require("redux-saga/effects");
var ChartStateType_1 = require("../../chart/states/ChartStateType");
var EstateState_1 = require("@/pages/estate/states/EstateState");
var padZero_1 = require("@/utils/padZero");
var getTrendTranslate = function (state) { return state.trends.t; };
var getDistrictId = function (state) { return state.place.id; };
var getIsUnavailable = function (state) { return state.page === Pages_1.Pages.DETAIL_NOT_FOUND || state.page === Pages_1.Pages.DETAIL_NOT_FOUND_AMP; };
var getEstatePhaseId = function (state) { return state.estate.id; };
var getIsEstate = function (state) { return state.estate.type === EstateState_1.EstatePhaseType.ESTATE; };
var getIsBlock = function (state) { return state.detail.building.isBlock; };
var getBuildingId = function (state) { return state.place.id; };
var getDetailBuilding = function (state) { return state.detail.building.id; };
var getChartGroups = function (state) { return state.trends.newChartGroups; };
var getPage = function (state) { return state.page; };
var getCustomFromTo = function (state) { return [state.trends.customFrom, state.trends.customTo]; };
var getCustomChartIndex = function (state, currentTypeIdx) { return state.trends.newChartGroups[currentTypeIdx].charts.findIndex(function (it) { return it.yearType === ChartRangeType_1.ChartRangeType.CUSTOM; }); };
var getCustomTypeIdx = function (state) { return state.trends.newChartGroups.findIndex(function (it) { return it.active; }); };
var getIsTypeActive = function (state) { return state.trends.isSelectTypeActive; };
var getIsDurationActive = function (state) { return state.trends.isSelectDurationActive; };
var getYCountNewValue = function (dataDTO, type) {
    return dataDTO.dataGroupExts.filter(function (it) { return it.haveData; }).map(function (it) { return it.dataPoints.map(function (it) { return it.count; }); }).slice(0, 1);
};
var getYValuesNewValue = function (dataDTO, type) {
    return dataDTO.dataGroupExts.reduce(function (result, r) {
        switch (type) {
            case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
                if (r.haveData) {
                    result.push(r.dataPoints.map(function (rx) { return rx.avg; }));
                }
                break;
            case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
                if (r.haveData) {
                    result.push(r.dataPoints.map(function (rx) { return rx.total; }));
                }
                break;
            case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
                if (r.haveData) {
                    result.push(r.dataPoints.map(function (rx) { return rx.count; }));
                }
                break;
            case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
                if (r.haveData) {
                    result = r.dataPoints.reduce(function (result2, rx, i) {
                        if (i === 0) {
                            result2 = rx.groupedCount.map(function (rx) { return [rx]; });
                        }
                        else {
                            rx.groupedCount.forEach(function (rxx, k) {
                                result2[k].push(rxx);
                            });
                        }
                        return result2;
                    }, []);
                }
                break;
        }
        return result;
    }, []);
};
var getBarColors = function (dataDTO, type) {
    return dataDTO.dataGroupExts.filter(function (it) { return it.haveData; }).flatMap(function (rxx) { return rxx.barColors; }).slice(0, 1);
};
var getBarOnHoverColors = function (dataDTO, type) {
    return dataDTO.dataGroupExts.filter(function (it) { return it.haveData; }).flatMap(function (rxx) { return rxx.barOnHoverColors; }).slice(0, 1);
};
var getYLabelNewValue = function (dataDTO, type) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
        case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
            return dataDTO.dataGroupExts.map(function (rxx) { return rxx.legendNames[0]; });
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            var list = dataDTO.dataGroupExts.find(function (rxx) { return rxx.legendNames.length; });
            return list ? list.legendNames : [];
    }
};
var getYColorNewValue = function (dataDTO, type) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
        case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
            return dataDTO.dataGroupExts.map(function (rxx) { return rxx.legendColor; });
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            var list = dataDTO.dataGroupExts.find(function (rxx) { return rxx.lineColors.length; });
            return list ? list.lineColors : [];
    }
    return [];
};
var getYLineColorNewValue = function (dataDTO, type) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
        case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
            return dataDTO.dataGroupExts.map(function (rxx) { return rxx.haveData ? rxx.legendColor : null; }).filter(function (rxx) { return rxx != null; });
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            var list = dataDTO.dataGroupExts.find(function (rxx) { return rxx.lineColors.length; });
            return list ? list.lineColors : [];
    }
    return [];
};
var getYTextColorNewValue = function (dataDTO, type) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
        case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
            return dataDTO.dataGroupExts.map(function (rxx) { return rxx.legendTextColor; });
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            var list = dataDTO.dataGroupExts.find(function (rxx) { return rxx.lineColors.length; });
            return list ? list.lineColors.map(function (rxx) { return "black"; }) : [];
    }
    return [];
};
var formatDateName = function (name) {
    if (!name)
        return '';
    var namePcs = name.split(' ');
    if (namePcs.length !== 2)
        return name;
    if (namePcs[0] === ("" + Number(namePcs[0])).padStart(2, '0') && namePcs[1] === ("" + Number(namePcs[1])).padStart(2, '0')) {
        return name.replace(' ', '/');
    }
    return name;
};
var getXLabelsNewValue = function (dataDTO, type) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT:
        case ChartGroupNewType_1.ChartGroupNewType.PRICERANGE:
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            return dataDTO.dataGroupExts.reduce(function (result, r) {
                if (!result.length) {
                    return r.dataPoints.length ? r.dataPoints.map(function (rx) { return formatDateName(rx.name); }) : [];
                }
                return result;
            }, []);
    }
    return [];
};
var getUseBar = function (type) {
    switch (type) {
        case ChartStateType_1.ChartStateType.Bar:
        case ChartStateType_1.ChartStateType.StackBar:
        case ChartStateType_1.ChartStateType.LineBar:
            return true;
    }
    return false;
};
var getNoticeText = function (dataDTO, type, page, t) {
    switch (type) {
        case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONBYPRICERANGE:
            return dataDTO.dataGroupExts.reduce(function (result, r) {
                if (!result.length) {
                    switch (page) {
                        case Pages_1.Pages.PROPERTY_DETAIL:
                        case Pages_1.Pages.BUILDING:
                            return r.dataGroupType !== DataGroupType_1.DataGroupType.BUILDING ? "" + t.showingDataOf.replace('{0}', r.dataGroupName) : '';
                    }
                }
                return result;
            }, '');
    }
    return '';
};
var processChart = function (response, currentCharts, selectedChartType, selectedChartYear) {
    var _a, data, getChartDatasetDTOs_1, page_1, tTrends_1, newCharts, newCharts;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(response && response.data)) return [3 /*break*/, 3];
                _a = response.data, data = _a === void 0 ? { getChartDatasetDTOs: [] } : _a;
                getChartDatasetDTOs_1 = data.getChartDatasetDTOs;
                return [4 /*yield*/, effects_1.select(getPage)];
            case 1:
                page_1 = _b.sent();
                return [4 /*yield*/, effects_1.select(getTrendTranslate)];
            case 2:
                tTrends_1 = _b.sent();
                newCharts = currentCharts.map(function (r, i) {
                    if (r.type === selectedChartType) {
                        var charts = r.charts.map(function (rx, j) {
                            var copyRx = __assign({}, rx);
                            if (copyRx.yearType == selectedChartYear) {
                                if (getChartDatasetDTOs_1.length === 0) {
                                    copyRx.isError = false;
                                    copyRx.isLoaded = true;
                                }
                                else {
                                    var dataDTO = getChartDatasetDTOs_1[0];
                                    var yLineColors = getYLineColorNewValue(dataDTO, r.type);
                                    copyRx.yTitle = dataDTO.yAxisLabel;
                                    copyRx.xLabels = getXLabelsNewValue(dataDTO, r.type);
                                    copyRx.yLabels = getYLabelNewValue(dataDTO, r.type);
                                    copyRx.yColors = getYColorNewValue(dataDTO, r.type);
                                    copyRx.yLineColors = yLineColors;
                                    copyRx.yTextColors = getYTextColorNewValue(dataDTO, r.type);
                                    copyRx.yCounts = getYCountNewValue(dataDTO, r.type);
                                    copyRx.yValues = getYValuesNewValue(dataDTO, r.type);
                                    copyRx.yCountColor = getBarColors(dataDTO, r.type);
                                    copyRx.yCountColor2 = getBarOnHoverColors(dataDTO, r.type);
                                    copyRx.yCountTitle = copyRx.yLabels.slice(0 - yLineColors.length).map(function (it) { return "" + tTrends_1.noOfTransactions; }).slice(0, 1);
                                    copyRx.useBar = getUseBar(dataDTO.chartType);
                                    copyRx.noticeText = getNoticeText(dataDTO, r.type, page_1, tTrends_1);
                                    copyRx.isError = false;
                                    copyRx.isLoaded = true;
                                }
                            }
                            return copyRx;
                        });
                        return __assign(__assign({}, r), { charts: charts });
                    }
                    return r;
                });
                return [2 /*return*/, newCharts];
            case 3:
                newCharts = currentCharts.map(function (r, i) {
                    if (r.type === selectedChartType) {
                        var charts = r.charts.map(function (rx, j) {
                            var copyRx = __assign({}, rx);
                            if (copyRx.yearType == selectedChartYear) {
                                copyRx.isError = true;
                                copyRx.isLoaded = false;
                            }
                            return copyRx;
                        });
                        return __assign(__assign({}, r), { charts: charts });
                    }
                    return r;
                });
                return [2 /*return*/, newCharts];
        }
    });
};
var groupChart = function (currentCharts, selectedChartType, selectedChartYearType, from, to) {
    var dataGroupType, targetId, page, _a, buildingId, isBlock, buildingId, isBlock, buildingId, buildingId, estatePhaseId, isEstate, districtId, response;
    if (from === void 0) { from = ""; }
    if (to === void 0) { to = ""; }
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dataGroupType = DataGroupType_1.DataGroupType.NONE;
                targetId = 0;
                return [4 /*yield*/, effects_1.select(getPage)];
            case 1:
                page = _b.sent();
                _a = page;
                switch (_a) {
                    case Pages_1.Pages.PROPERTY_DETAIL: return [3 /*break*/, 2];
                    case Pages_1.Pages.PROPERTY_TRANSACTION: return [3 /*break*/, 5];
                    case Pages_1.Pages.BUILDING: return [3 /*break*/, 8];
                    case Pages_1.Pages.BLOCK: return [3 /*break*/, 10];
                    case Pages_1.Pages.ESTATE: return [3 /*break*/, 12];
                    case Pages_1.Pages.DISTRICT: return [3 /*break*/, 15];
                }
                return [3 /*break*/, 17];
            case 2: return [4 /*yield*/, effects_1.select(getDetailBuilding)];
            case 3:
                buildingId = _b.sent();
                return [4 /*yield*/, effects_1.select(getIsBlock)];
            case 4:
                isBlock = _b.sent();
                targetId = buildingId;
                dataGroupType = isBlock ? DataGroupType_1.DataGroupType.BLOCK : DataGroupType_1.DataGroupType.BUILDING;
                return [3 /*break*/, 17];
            case 5: return [4 /*yield*/, effects_1.select(getDetailBuilding)];
            case 6:
                buildingId = _b.sent();
                return [4 /*yield*/, effects_1.select(getIsBlock)];
            case 7:
                isBlock = _b.sent();
                targetId = buildingId;
                dataGroupType = isBlock ? DataGroupType_1.DataGroupType.BLOCK : DataGroupType_1.DataGroupType.BUILDING;
                return [3 /*break*/, 17];
            case 8: return [4 /*yield*/, effects_1.select(getBuildingId)];
            case 9:
                buildingId = _b.sent();
                targetId = buildingId;
                dataGroupType = DataGroupType_1.DataGroupType.BUILDING;
                return [3 /*break*/, 17];
            case 10: return [4 /*yield*/, effects_1.select(getBuildingId)];
            case 11:
                buildingId = _b.sent();
                targetId = buildingId;
                dataGroupType = DataGroupType_1.DataGroupType.BLOCK;
                return [3 /*break*/, 17];
            case 12: return [4 /*yield*/, effects_1.select(getEstatePhaseId)];
            case 13:
                estatePhaseId = _b.sent();
                return [4 /*yield*/, effects_1.select(getIsEstate)];
            case 14:
                isEstate = _b.sent();
                targetId = estatePhaseId;
                dataGroupType = isEstate ? DataGroupType_1.DataGroupType.ESTATE : DataGroupType_1.DataGroupType.PHASE;
                return [3 /*break*/, 17];
            case 15: return [4 /*yield*/, effects_1.select(getDistrictId)];
            case 16:
                districtId = _b.sent();
                targetId = districtId;
                dataGroupType = DataGroupType_1.DataGroupType.DISTRICT;
                return [3 /*break*/, 17];
            case 17: return [4 /*yield*/, effects_1.call(ChartApiSaga_1.getChartApi, targetId, dataGroupType, selectedChartType, selectedChartYearType, from, to)];
            case 18:
                response = _b.sent();
                return [4 /*yield*/, effects_1.call(processChart, response, currentCharts, selectedChartType, selectedChartYearType)];
            case 19: return [2 /*return*/, _b.sent()];
        }
    });
};
var watchInitChart = function () {
    var isUnavailable;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsUnavailable)];
            case 2:
                isUnavailable = _a.sent();
                if (isUnavailable)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartTypeSelect(ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var rangeToNumber = function (range) {
    switch (range) {
        case ChartRangeType_1.ChartRangeType.ONE: return 1;
        case ChartRangeType_1.ChartRangeType.THREE: return 3;
        case ChartRangeType_1.ChartRangeType.FIVE: return 5;
        case ChartRangeType_1.ChartRangeType.TEN: return 10;
    }
    return -1;
};
var toFromDateString = function (now, range) {
    var yearNumber = rangeToNumber(range);
    if (yearNumber === -1)
        return '2006-01-01';
    return now.getFullYear() - yearNumber + "-01-01";
};
var watchSwitchYearIndex = function () {
    var _loop_1, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, currentCharts, selectedChart, selectedChartType, selectedChartYear, selectedChartYearType, now, from, to;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(TrendsAction_1.default.TRENDS_ON_CHART_INDEX_SELECT)];
                            case 1:
                                payload = (_a.sent()).payload;
                                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setChartPopup(null))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setChartIndex(payload))];
                            case 3:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getChartGroups)];
                            case 4:
                                currentCharts = _a.sent();
                                selectedChart = currentCharts.find(function (r) { return r.active; });
                                if (!selectedChart)
                                    return [2 /*return*/, { value: void 0 }];
                                selectedChartType = selectedChart.type;
                                selectedChartYear = selectedChart.charts[payload];
                                selectedChartYearType = selectedChartYear.yearType;
                                if (!(selectedChartYearType !== ChartRangeType_1.ChartRangeType.CUSTOM)) return [3 /*break*/, 6];
                                now = new Date();
                                from = toFromDateString(now, selectedChartYearType);
                                to = now.getFullYear() + "-" + padZero_1.padZero(now.getMonth(), 2) + "-" + padZero_1.padZero(now.getDate(), 2);
                                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onCustomFromToChange(from, to))];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                if (selectedChartYear.isLoaded)
                                    return [2 /*return*/, "continue"];
                                return [4 /*yield*/, effects_1.fork(function () {
                                        var newCharts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(selectedChartYearType === ChartRangeType_1.ChartRangeType.CUSTOM)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, effects_1.call(onCustomFromToChanged)];
                                                case 1:
                                                    _a.sent();
                                                    return [3 /*break*/, 5];
                                                case 2: return [4 /*yield*/, effects_1.call(groupChart, currentCharts, selectedChartType, selectedChartYearType)];
                                                case 3:
                                                    newCharts = _a.sent();
                                                    return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartGroupUpdated(newCharts))];
                                                case 4:
                                                    _a.sent();
                                                    _a.label = 5;
                                                case 5: return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 7:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var showCustomChart = function (from, to) {
    var groups, currentGroup, currentGroupType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setChartPopup(null))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getChartGroups)];
            case 2:
                groups = _a.sent();
                currentGroup = groups.find(function (r) { return r.active; });
                currentGroupType = currentGroup.type;
                return [4 /*yield*/, effects_1.fork(function () {
                        var newGroups;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, effects_1.call(groupChart, groups, currentGroupType, ChartRangeType_1.ChartRangeType.CUSTOM, from, to)];
                                case 1:
                                    newGroups = _a.sent();
                                    return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartGroupUpdated(newGroups))];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSwitchChartIndex = function () {
    var _loop_2, state_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_2 = function () {
                    var payload, currentCharts, selectedChart, selectedChartType, selectedChartYear, selectedChartYearType;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(TrendsAction_1.default.TRENDS_ON_CHART_TYPE_SELECT)];
                            case 1:
                                payload = (_a.sent()).payload;
                                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setChartPopup(null))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setChartType(payload))];
                            case 3:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getChartGroups)];
                            case 4:
                                currentCharts = _a.sent();
                                selectedChart = currentCharts.find(function (r) { return r.type == payload; });
                                if (!selectedChart)
                                    return [2 /*return*/, { value: void 0 }];
                                selectedChartType = selectedChart.type;
                                selectedChartYear = selectedChart.charts.find(function (r) { return r.active; });
                                selectedChartYearType = selectedChartYear.yearType;
                                if (selectedChartYear.isLoaded)
                                    return [2 /*return*/, "continue"];
                                return [4 /*yield*/, effects_1.fork(function () {
                                        var newCharts;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, effects_1.call(groupChart, currentCharts, selectedChartType, selectedChartYearType)];
                                                case 1:
                                                    newCharts = _a.sent();
                                                    return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartGroupUpdated(newCharts))];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    })];
                            case 5:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_2()];
            case 2:
                state_2 = _a.sent();
                if (typeof state_2 === "object")
                    return [2 /*return*/, state_2.value];
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var checkFromToValid = function (from, to) {
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var now = new Date();
    if (!fromDate.getDate() || !toDate.getDate())
        return false;
    if (fromDate.getTime() >= toDate.getTime())
        return false;
    if (fromDate.getFullYear() <= 1990)
        return false;
    if (toDate.getFullYear() > now.getFullYear())
        return false;
    return true;
};
var onCustomFromToChanged = function () {
    var _a, from, to, isValid;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.select(getCustomFromTo)];
            case 1:
                _a = _b.sent(), from = _a[0], to = _a[1];
                return [4 /*yield*/, effects_1.call(checkFromToValid, from, to)];
            case 2:
                isValid = _b.sent();
                if (!isValid)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartCustomChanged(from, to))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
};
var watchCustomFromToChanged = function () {
    var typeIdx, customChartIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take([TrendsAction_1.default.TRENDS_ON_CHART_CUSTOM_FROM_CHANGE, TrendsAction_1.default.TRENDS_ON_CHART_CUSTOM_TO_CHANGE])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCustomTypeIdx)];
            case 2:
                typeIdx = _a.sent();
                return [4 /*yield*/, effects_1.select(getCustomChartIndex, typeIdx)];
            case 3:
                customChartIndex = _a.sent();
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.onChartIndexSelect(customChartIndex))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(onCustomFromToChanged)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var delayShowCustomChart = function (from, to) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(showCustomChart, from, to)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchCustomChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(TrendsAction_1.default.TRENDS_ON_CHART_CUSTOM_CHANGED, function (action) {
                    var payload, fromStr, toStr, from, to;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                payload = action.payload;
                                fromStr = payload.from;
                                toStr = payload.to;
                                from = new Date(fromStr).toJSON();
                                to = new Date(toStr.replace('00:00:00', '23:59:59')).toJSON();
                                return [4 /*yield*/, effects_1.call(delayShowCustomChart, from, to)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSelectTypeClicked = function () {
    var typeActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(TrendsAction_1.default.TRENDS_ON_SELECT_TYPE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsTypeActive)];
            case 2:
                typeActive = _a.sent();
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setSelectDurationActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setSelectTypeActive(!typeActive))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchSelectDurationClicked = function () {
    var durationActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(TrendsAction_1.default.TRENDS_ON_SELECT_DURATION_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsDurationActive)];
            case 2:
                durationActive = _a.sent();
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setSelectTypeActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(TrendsAction_1.default.setSelectDurationActive(!durationActive))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var rootTrendsSagas = {
    watchInitChart: watchInitChart,
    watchSwitchChartIndex: watchSwitchChartIndex,
    watchSwitchYearIndex: watchSwitchYearIndex,
    watchCustomFromToChanged: watchCustomFromToChanged,
    watchCustomChanged: watchCustomChanged,
    watchSelectTypeClicked: watchSelectTypeClicked,
    watchSelectDurationClicked: watchSelectDurationClicked,
};
exports.rootTrendsSagas = rootTrendsSagas;
